/**
 * Checks if URL parameter is set.
 * @param {string} param
 * @return {bool}
 */
export const hasParam = ( param ) => {
	const urlParams = new URLSearchParams( window.location.search );
	return !!urlParams.get( param );
};

/**
 * Returns true if the user has the specified subtype.
 * @param {object} user
 * @param {string} subtype
 * @return {bool}
 */
export const hasUserType = ( user, subtype ) => {
	return !!user && user.subtype === subtype;
};

/**
 * Returns true if the group has the specified subtype.
 * @param {object} group
 * @param {string} subtype
 * @return {bool}
 */
export const hasGroupType = ( group, subtype ) => {
	return !!group && group.subtype === subtype;
};

/**
 * Returns true if the user is an admin of the group.
 * @param {object} groups_user
 * @return {bool}
 */
export const isGroupAdmin = ( groups_user ) => {
	return !!groups_user && groups_user.is_admin;
};

/**
 * Returns Auth0 access token for logged-in user
 * @returns {string}
 */
export const getAccessToken = () => {
	let token = '', value = '';
	Object.keys( localStorage ).forEach( key => {
		if ( key.includes( 'realintro' ) ) {
			value = localStorage.getItem( key );
		}
	} );
	try {
		let obj = JSON.parse( value );
		token = obj.body.access_token;
	} catch ( error ) {
		console.error( 'Failed to parse JSON:', error.message );
	}
	return token;
};
